export default "__VITE_ASSET__DKRojGey__"